// ISO 639-1
// https://github.com/cospired/i18n-iso-languages/blob/main/langs
export var Lang;
(function (Lang) {
    // Bambara
    Lang["bm"] = "bm";
    // Bashkir
    Lang["ba"] = "ba";
    // Basque
    Lang["eu"] = "eu";
    // Belarusian
    Lang["be"] = "be";
    // Bengali
    Lang["bn"] = "bn";
    // Bihari languages
    Lang["bh"] = "bh";
    // Bislama
    Lang["bi"] = "bi";
    // Bosnian
    Lang["bs"] = "bs";
    // Breton
    Lang["br"] = "br";
    // Bulgarian
    Lang["bg"] = "bg";
    // Burmese
    Lang["my"] = "my";
    // Catalan, Valencian
    Lang["ca"] = "ca";
    // Chamorro
    Lang["ch"] = "ch";
    // Chechen
    Lang["ce"] = "ce";
    // Chichewa, Chewa, Nyanja
    Lang["ny"] = "ny";
    // Chinese
    Lang["zh"] = "zh";
    // Chuvash
    Lang["cv"] = "cv";
    // Cornish
    Lang["kw"] = "kw";
    // Corsican
    Lang["co"] = "co";
    // Cree
    Lang["cr"] = "cr";
    // Croatian
    Lang["hr"] = "hr";
    // Czech
    Lang["cs"] = "cs";
    // Danish
    Lang["da"] = "da";
    // Divehi, Dhivehi, Maldivian
    Lang["dv"] = "dv";
    // Dutch, Flemish
    Lang["nl"] = "nl";
    // Dzongkha
    Lang["dz"] = "dz";
    // English
    Lang["en"] = "en";
    // Esperanto
    Lang["eo"] = "eo";
    // Estonian
    Lang["et"] = "et";
    // Ewe
    Lang["ee"] = "ee";
    // Faroese
    Lang["fo"] = "fo";
    // Fijian
    Lang["fj"] = "fj";
    // Finnish
    Lang["fi"] = "fi";
    // French
    Lang["fr"] = "fr";
    // Fulah
    Lang["ff"] = "ff";
    // Galician
    Lang["gl"] = "gl";
    // Georgian
    Lang["ka"] = "ka";
    // German
    Lang["de"] = "de";
    // Greek, Modern (1453–)
    Lang["el"] = "el";
    // Guarani
    Lang["gn"] = "gn";
    // Gujarati
    Lang["gu"] = "gu";
    // Haitian, Haitian Creole
    Lang["ht"] = "ht";
    // Hausa
    Lang["ha"] = "ha";
    // Hebrew
    Lang["he"] = "he";
    // Herero
    Lang["hz"] = "hz";
    // Hindi
    Lang["hi"] = "hi";
    // Hiri Motu
    Lang["ho"] = "ho";
    // Hungarian
    Lang["hu"] = "hu";
    // Interlingua (International Auxiliary Language Association)
    Lang["ia"] = "ia";
    // Indonesian
    Lang["id"] = "id";
    // Interlingue, Occidental
    Lang["ie"] = "ie";
    // Irish
    Lang["ga"] = "ga";
    // Igbo
    Lang["ig"] = "ig";
    // Inupiaq
    Lang["ik"] = "ik";
    // Ido
    Lang["io"] = "io";
    // Icelandic
    Lang["is"] = "is";
    // Italian
    Lang["it"] = "it";
    // Inuktitut
    Lang["iu"] = "iu";
    // Japanese
    Lang["ja"] = "ja";
    // Javanese
    Lang["jv"] = "jv";
    // Kalaallisut, Greenlandic
    Lang["kl"] = "kl";
    // Kannada
    Lang["kn"] = "kn";
    // Kanuri
    Lang["kr"] = "kr";
    // Kashmiri
    Lang["ks"] = "ks";
    // Kazakh
    Lang["kk"] = "kk";
    // Central Khmer
    Lang["km"] = "km";
    // Kikuyu, Gikuyu
    Lang["ki"] = "ki";
    // Kinyarwanda
    Lang["rw"] = "rw";
    // Kirghiz, Kyrgyz
    Lang["ky"] = "ky";
    // Komi
    Lang["kv"] = "kv";
    // Kongo
    Lang["kg"] = "kg";
    // Korean
    Lang["ko"] = "ko";
    // Kurdish
    Lang["ku"] = "ku";
    // Kuanyama, Kwanyama
    Lang["kj"] = "kj";
    // Latin
    Lang["la"] = "la";
    // Luxembourgish, Letzeburgesch
    Lang["lb"] = "lb";
    // Ganda
    Lang["lg"] = "lg";
    // Limburgan, Limburger, Limburgish
    Lang["li"] = "li";
    // Lingala
    Lang["ln"] = "ln";
    // Lao
    Lang["lo"] = "lo";
    // Lithuanian
    Lang["lt"] = "lt";
    // Luba-Katanga
    Lang["lu"] = "lu";
    // Latvian
    Lang["lv"] = "lv";
    // Manx
    Lang["gv"] = "gv";
    // Macedonian
    Lang["mk"] = "mk";
    // Malagasy
    Lang["mg"] = "mg";
    // Malay
    Lang["ms"] = "ms";
    // Malayalam
    Lang["ml"] = "ml";
    // Maltese
    Lang["mt"] = "mt";
    // Maori
    Lang["mi"] = "mi";
    // Marathi
    Lang["mr"] = "mr";
    // Marshallese
    Lang["mh"] = "mh";
    // Mongolian
    Lang["mn"] = "mn";
    // Nauru
    Lang["na"] = "na";
    // Navajo, Navaho
    Lang["nv"] = "nv";
    // North Ndebele
    Lang["nd"] = "nd";
    // Nepali
    Lang["ne"] = "ne";
    // Ndonga
    Lang["ng"] = "ng";
    // Norwegian Bokmål
    Lang["nb"] = "nb";
    // Norwegian Nynorsk
    Lang["nn"] = "nn";
    // Norwegian
    Lang["no"] = "no";
    // Sichuan Yi, Nuosu
    Lang["ii"] = "ii";
    // South Ndebele
    Lang["nr"] = "nr";
    // Occitan
    Lang["oc"] = "oc";
    // Ojibwa
    Lang["oj"] = "oj";
    // Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic
    Lang["cu"] = "cu";
    // Oromo
    Lang["om"] = "om";
    // Oriya
    Lang["or"] = "or";
    // Ossetian, Ossetic
    Lang["os"] = "os";
    // Punjabi, Panjabi
    Lang["pa"] = "pa";
    // Pali
    Lang["pi"] = "pi";
    // Persian
    Lang["fa"] = "fa";
    // Polish
    Lang["pl"] = "pl";
    // Pashto, Pushto
    Lang["ps"] = "ps";
    // Portuguese
    Lang["pt"] = "pt";
    // Quechua
    Lang["qu"] = "qu";
    // Romansh
    Lang["rm"] = "rm";
    // Rundi
    Lang["rn"] = "rn";
    // Romanian, Moldavian, Moldovan
    Lang["ro"] = "ro";
    // Russian
    Lang["ru"] = "ru";
    // Sanskrit
    Lang["sa"] = "sa";
    // Sardinian
    Lang["sc"] = "sc";
    // Sindhi
    Lang["sd"] = "sd";
    // Northern Sami
    Lang["se"] = "se";
    // Samoan
    Lang["sm"] = "sm";
    // Sango
    Lang["sg"] = "sg";
    // Serbian
    Lang["sr"] = "sr";
    // Gaelic, Scottish Gaelic
    Lang["gd"] = "gd";
    // Shona
    Lang["sn"] = "sn";
    // Sinhala, Sinhalese
    Lang["si"] = "si";
    // Slovak
    Lang["sk"] = "sk";
    // Slovenian
    Lang["sl"] = "sl";
    // Somali
    Lang["so"] = "so";
    // Southern Sotho
    Lang["st"] = "st";
    // Spanish, Castilian
    Lang["es"] = "es";
    // Sundanese
    Lang["su"] = "su";
    // Swahili
    Lang["sw"] = "sw";
    // Swati
    Lang["ss"] = "ss";
    // Swedish
    Lang["sv"] = "sv";
    // Tamil
    Lang["ta"] = "ta";
    // Telugu
    Lang["te"] = "te";
    // Tajik
    Lang["tg"] = "tg";
    // Thai
    Lang["th"] = "th";
    // Tigrinya
    Lang["ti"] = "ti";
    // Tibetan
    Lang["bo"] = "bo";
    // Turkmen
    Lang["tk"] = "tk";
    // Tagalog
    Lang["tl"] = "tl";
    // Tswana
    Lang["tn"] = "tn";
    // Tonga (Tonga Islands)
    Lang["to"] = "to";
    // Turkish
    Lang["tr"] = "tr";
    // Tsonga
    Lang["ts"] = "ts";
    // Tatar
    Lang["tt"] = "tt";
    // Twi
    Lang["tw"] = "tw";
    // Tahitian
    Lang["ty"] = "ty";
    // Uighur, Uyghur
    Lang["ug"] = "ug";
    // Ukrainian
    Lang["uk"] = "uk";
    // Urdu
    Lang["ur"] = "ur";
    // Uzbek
    Lang["uz"] = "uz";
    // Venda
    Lang["ve"] = "ve";
    // Vietnamese
    Lang["vi"] = "vi";
    // Volapük
    Lang["vo"] = "vo";
    // Walloon
    Lang["wa"] = "wa";
    // Welsh
    Lang["cy"] = "cy";
    // Wolof
    Lang["wo"] = "wo";
    // Western Frisian
    Lang["fy"] = "fy";
    // Xhosa
    Lang["xh"] = "xh";
    // Yiddish
    Lang["yi"] = "yi";
    // Yoruba
    Lang["yo"] = "yo";
    // Zhuang, Chuang
    Lang["za"] = "za";
    // Zulu
    Lang["zu"] = "zu";
})(Lang || (Lang = {}));
//# sourceMappingURL=Lang.js.map